/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment } from 'react';
import { Link, withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Checkbox, Drawer, Button, notification, Tooltip, Select, Divider, Popover,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import OfferActions from '@Actions/offerActions';
import MrpV2Actions from '@Actions/production/mrpV2Actions';
import SelectOffer from '@Components/Common/SelectOffer';
import H3Progress from '@Components/Common/H3Progress';
import loaderImg from '@Images/loader.gif';
import Helpers from '@Apis/helpers';
import ReserveMrpStockItems from './ReserveMrpStockItems';
import PRFromMaterialShortage from './PRFromMaterialShortage';
import './style.scss';
import LinkExistingPoToMrp from './LinkExistingPoToMrp';
import EditPurchaseLinkAndUnlink from './EditPurchaseLinkAndUnlink';
import CreatePurchaseRequest from '../../../../Purchase/PurchaseRequests/CreatePurchaseRequest';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import PRZSelect from '../../../../Common/UI/PRZSelect';
import { GetDocSequence } from '../../../../../modules/documentSequence';
import PurchaseIndentForm from '../../../../Purchase/PurchaseIndent/PurchaseIndentForm';
import TaxActions from '@Actions/taxActions';


const { Option } = Select;

function MaterialShortage({
  user, MONEY, getLinkedMOLoading, getStockItems, getStockItemsShortageLoading, stockItemsShortage, getStockItemsSuccess, pushToProductionItemsLoading, pushToStockItemsLoading, getDocCFV2,
  updateMrpV2, updateMrpV2Loading, getMrpV2, match, updateMrpStockItems, getOffers, mrpData, reserveShortageMrp, reserveShortageMrpLoading, poCreateCallback, clearReservation, clearReservationLoading, updateMrpStockItemsLoading,
  call, getMrpSummary, priceMasking, documentSequence, getDocSequence, getTaxes, getTaxesLoading, getTaxesSuccess
}) {
  const [selectedMaterialShortageItemRows, setSelectedMaterialShortageItemRows] = useState([]);
  const [selectedMaterialShortageItemRowKeys, setSelectedMaterialShortageItemRowKeys] = useState([]);

  // Stock Items
  const [callStockItem, setCallStockItem] = useState(false);
  const [consolidateStockItems, setConsolidateStockItems] = useState(false);
  const [ignoreStockItemsAvailableStock, setIgnoreStockItemsAvailableStock] = useState(false);
  const [ignoreStockItemsSafetyStock, setIgnoreStockItemsSafetyStock] = useState(false);
  const [ignoreStockItemsReservedStock, setIgnoreStockItemsReservedStock] = useState(false);
  const [selectOfferVisible, setSelectOfferVisible] = useState(false);
  const [currentLine, setCurrentLine] = useState({});
  const [createPurchaseDrawer, setCreatePurchaseDrawer] = useState(false);
  const [reserveDrawerOpen, setReserveDrawerOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [selectedPurchaseRequest, setSelectedPurchaseRequest] = useState(null);
  const [tenantSellerPRItemsData, setTenantSellerPRItemsData] = useState({});
  const [linkExistingPoToMrpDrawer, setLinkExistingPoToMrpDrawer] = useState(false);
  const [editPurchaseLinkAndUnlinkDrawer, setEditPurchaseLinkAndUnlinkDrawer] = useState(false);
  const [dataForLinkAndUnlinkPo, setDataForLinkAndUnlinkPo] = useState(false);
  const [createPurchaseRequestDrawer, setCreatePurchaseRequestDrawer] = useState(false);
  const [createPurchaseIndentDrawer, setCreatePurchaseIndentDrawer] = useState(false);
  const [cfPurchaseOrdersDoc, setCfPurchaseOrdersDoc] = useState({});
  const [cfPurchaseOrdersLine, setCfPurchaseOrdersLine] = useState({});
  const [visibleColumns, setVisibleColumns] = useState(
    {
      PRODUCT: {
        label: 'Product',
        visible: true,
        disabled: true,
      },
      QUANTITY: {
        label: 'Quantity',
        visible: true,
        disabled: true,
      },
      UNIT: {
        label: 'Unit',
        visible: true,
        disabled: true,
      },
      UNIT_PRICE: {
        label: 'Rate',
        visible: true,
        disabled: true,
      },
      TAX: {
        label: 'Tax',
        visible: true,
        disabled: true,
      },
      DISCOUNT: {
        label: 'Discount',
        visible: true,
        disabled: true,
      },
      LINE_TOTAL: {
        label: 'Line Total',
        visible: true,
        disabled: true,
      },
    }
  );
  const [taxesGroupData, setTaxesGroupData] = useState([]);

  const location = useLocation();

  const isPoFromMrpInPurchaseUomEnable = user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.create_po_from_mrp_in_purchase_uom;
  const mrpId = match.params?.mrpId;

  useEffect(() => {
    getMrpSummary({ mrpId: Number(mrpId) }, () => { });
  }, [callStockItem]);

  useEffect(() => {
    getMrpV2({
      tenantId: mrpData?.tenant_id,
      listScreen: false,
      mrpId: Number(mrpId),
    }, (mrpV2Data) => {
      // Stock Items
      setConsolidateStockItems(mrpV2Data?.consolidate_requirement_mrp_stock_items);
      setIgnoreStockItemsAvailableStock(mrpV2Data?.ignore_available_stock_mrp_stock_items);
      setIgnoreStockItemsSafetyStock(mrpV2Data?.ignore_safety_stock_mrp_stock_items);
      setIgnoreStockItemsReservedStock(mrpV2Data?.ignore_reserved_stock_mrp_stock_items);
    });

    const tab = location.search?.split('=')?.[1];
    if (tab === 'materials_shortage') {
      setCallStockItem(!callStockItem);
    }

  }, [location.search]);
  useEffect(() => {
    if (mrpData?.tenant_id) {
      getDocSequence({
        query: {
          tenant_id: mrpData?.tenant_id,
          entity_name: 'PURCHASE_ORDER',
        },
      });
    }
  }, [mrpData?.tenant_id]);

  useEffect(() => {
    getStockItems({ mrpId: Number(mrpId), entityType: 'SHORTAGE' }, () => {
      setSelectedMaterialShortageItemRows([]);
      setSelectedMaterialShortageItemRowKeys([]);
    });
  }, [callStockItem, call]);

  useEffect(() => {
    getTaxes(user?.tenant_info?.org_id, 1, 1000, null, true, (data) => {
      setTaxesGroupData(data);
    });

    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PURCHASE_ORDERS',
    };

    getDocCFV2(payload, (cfData) => {
      const documentCustomFields = CustomFieldHelpers.getCfStructure(
        cfData?.data?.document_custom_fields,
        true
      );

      const lineCustomFields = CustomFieldHelpers.getCfStructure(
        cfData?.data?.document_line_custom_fields?.filter((item) => item?.is_active),
        false
      );
      const visibleColumnsforTable = CustomFieldHelpers.updateVisibleColumns(cfData?.data?.document_line_custom_fields, visibleColumns)
      setCfPurchaseOrdersDoc(documentCustomFields);
      setCfPurchaseOrdersLine(lineCustomFields);
      setVisibleColumns(visibleColumnsforTable);
    });

    return () => {
      getTaxesSuccess(null);
    };
  }, []);

  const handleSellerSelection = (lineId, sellerInfo, orderLineId, moLineId) => {
    const payload = {
      mrp_id: mrpId,
      order_line_id: orderLineId || null,
      mo_line_id: moLineId || null,
      sku_offer_id: sellerInfo?.sku_offer_id || sellerInfo,
    };
    updateMrpStockItems(payload, () => {
      setCallStockItem(!callStockItem);
    });
  };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getStockItemsColumns = () => {
    const mrpColumns = [
      {
        title: 'SKU#',
        fixed: 'left',
        width: '180px',
        render: (record) => (
          <Fragment>
            <Popover
              content={(
                <div style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  padding: '4px',
                }}
                >
                  {`${record?.internal_sku_code || ''} - ${record?.product_sku_name || ''}`}<br />
                  {record?.lines[0]?.product_category_info?.category_path?.length > 0 && (
                    <ProductCategoryLabel
                      categoryPath={record?.lines[0]?.product_category_info?.category_path}
                      categoryName={record?.lines[0]?.product_category_info?.category_path?.at(-1)}
                      containerStyle={{
                        width: "fit-content",
                      }}
                    />
                  )}
                </div>
              )}
              trigger="hover"
              placement="bottomLeft"
            >
              {record?.product_sku_name ? (
                <div className="material-shortage-sku-name">
                  <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                    {`#${record?.internal_sku_code}`}
                  </Link>
                  <span>
                    {` - ${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`}
                  </span>
                </div>
              ) : '-'}
            </Popover>
            <div style={{ fontSize: '11px' }}>
              {record?.mo_number ? (
                <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
                  {record?.mo_number}
                </Link>
              ) : (
                <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                  {record?.sales_order_number}
                </Link>
              )}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Order#',
        fixed: 'left',
        width: '180px',
        render: (record) => (
          <div style={{ width: '164px' }}>
            {record?.mo_number ? (
              <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
                {record?.mo_number}
              </Link>
            ) : (
              <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                {record?.sales_order_number}
              </Link>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY((record?.issued_quantity ? record?.issued_quantity : record?.invoiced_quantity) || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {`${QUANTITY((record?.reserved_quantity), record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
                  </div>
                  {!consolidateStockItems && (Number(record?.available_quantity) + Number(record?.reserved_quantity)) > 0 && (
                    <div
                      className="material-shortage__reserve-button"
                      onClick={() => {
                        setReserveDrawerOpen(true);
                        setOrder(record);
                      }}
                    >
                      <EditOutlined />
                    </div>
                  )}
                </div>
                <div style={{
                  paddingRight: '5px', width: '80px', cursor: 'pointer',
                }}
                >
                  <Popover
                    title={(
                      <div>
                        <H3Text text={`${record?.demand_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                        <H3Text text={`${record?.reserved_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                      </div>
                    )}
                    zIndexPopup={99999}
                  >
                    <H3Progress percent={Math.round(parseInt((record?.reserved_quantity / record?.demand_quantity) * 100))} barWidth="150px" />
                  </Popover>
                </div>
              </Fragment>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Pending From Vendor',
        width: '140px',
        render: (record) => (
          <div style={{
            minWidth: '70px', display: 'flex', alignItems: 'center', gap: '5px',
          }}
          >
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div>
                {`${QUANTITY(record?.purchase_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : (
              '-'
            )}
            {mrpData?.status !== 'CLOSED' && (
              <EditOutlined
                style={{
                  color: '#2d7df7',
                }}
                onClick={() => {
                  setEditPurchaseLinkAndUnlinkDrawer(true);
                  setDataForLinkAndUnlinkPo(record);
                }}
              />
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Safety Stock',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div className={ignoreStockItemsSafetyStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.threshold_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div className={ignoreStockItemsAvailableStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.available_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'To Be Ordered',
        width: '110px',
        fixed: 'right',
        render: (record) => (
          <div>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Vendor',
        fixed: 'right',
        width: '200px',
        className: 'material-shortage__vendor-column',
        render: (record) => (
          <div>
            <PRZSelect
              value={record?.sku_offer_id}
              filterOption={false}
              // getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placeholder={(
                <span className="material-shortage__vendor-column-empty">
                  <FontAwesomeIcon icon={faCircleExclamation} />
                  {' '}
                  &nbsp;Vendor Not Selected
                </span>
              )}
              onChange={(value) => {
                handleSellerSelection('', value, record?.order_line_id, record?.mo_line_id);
              }}
              popupClassName="material-shortage__vendor-dropdown"
              dropdownRender={(menu) => (
                <React.Fragment>
                  {menu}
                  <Divider style={{ margin: '0px' }} />
                  <div
                    className="add__vendor"
                    onClick={() => {
                      setSelectOfferVisible(true);
                      setCurrentLine({
                        ...record,
                        tenantProductId: record?.tenant_product_id,
                        productName: record?.product_sku_name,
                        productSkuId: record?.product_sku_info?.product_sku_id,
                      });
                      getOffers(record.tenant_product_id, '');
                    }}
                    style={{ cursor: 'pointer', padding: '8px' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',

                      }}
                    >
                      <FontAwesomeIcon icon={faGears} />

                      {' '}
                      Manage Vendors
                    </div>
                  </div>
                </React.Fragment>
              )}
            >
              {record?.sku_offers?.map((offer) => (
                <Option key={offer.sku_offer_id} value={offer.sku_offer_id}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  >
                    <div
                      style={{
                        fontWeight: '600', fontSize: '13px', marginRight: '5px',
                      }}
                    >
                      {offer?.seller_info?.seller_name?.length > 25 ? `${offer?.seller_info?.seller_name?.substr(0, 20)}...` : offer?.seller_info?.seller_name}
                    </div>
                    <div className="material-shortage__offer-info">
                      <div className="material-shortage__offer-price">
                        {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"} /> : MONEY(offer?.offer_price)}
                        {' '}
                        &nbsp;
                      </div>
                      {offer?.is_preferred_supplier && (
                        <div
                          className="status-tag"
                          style={{ backgroundColor: 'orange' }}
                        >
                          Preferred
                        </div>
                      )}
                    </div>
                  </div>
                </Option>
              ))}
            </PRZSelect>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Selected Vendor',
        fixed: 'right',
        width: '200px',
        className: 'material-shortage__vendor-column',
        render: (record) => {
          const defaultSellerNames = record?.default_seller_names || [];
          const numberOfSellers = defaultSellerNames.length;
          const vendorDisplayText = numberOfSellers > 0 && `+ ${numberOfSellers - 1} more`;
          const tooltipText = numberOfSellers > 1 ? defaultSellerNames.slice(1).join(', ') : 'No additional vendors';
          const skyOfferIds = record?.lines?.filter((item) => item?.sku_offer_id)?.map((item) => item?.sku_offer_id);
          return (
            <div>
              <PRZSelect
                value={skyOfferIds}
                filterOption={false}
                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder={(
                  <span className="material-shortage__vendor-column-empty">
                    <FontAwesomeIcon icon={faCircleExclamation} />
                    {' '}
                    &nbsp;Vendor Not Selected
                  </span>
                )}
                onChange={(value) => {
                  handleSellerSelection('', value, record?.lines?.map((item) => item?.order_line_id), record?.lines?.map((item) => item?.mo_line_id));
                }}
                popupClassName="material-shortage__vendor-dropdown"
                dropdownRender={(menu) => (
                  <React.Fragment>
                    {menu}
                    <Divider style={{ margin: '0px' }} />
                    <div
                      className="add__vendor"
                      onClick={() => {
                        setSelectOfferVisible(true);
                        setCurrentLine({
                          ...record,
                          tenantProductId: record?.lines?.[0]?.tenant_product_id,
                          productName: record?.lines?.[0]?.product_sku_name,
                          productSkuId: record?.lines?.[0]?.product_sku_info?.product_sku_id,
                        });
                        getOffers(record?.lines?.[0]?.tenant_product_id, '');
                      }}
                      style={{ cursor: 'pointer', padding: '8px' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '5px',
                        }}
                      >
                        <FontAwesomeIcon icon={faGears} />

                        {' '}
                        Manage Vendors
                      </div>
                    </div>
                  </React.Fragment>
                )}
              >
                {record?.lines?.[0]?.sku_offers?.map((offer) => (
                  <Option key={offer.sku_offer_id} value={offer.sku_offer_id}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    >
                      <div
                        style={{
                          fontWeight: '600', fontSize: '13px', marginRight: '5px',
                        }}
                      >
                        {offer?.seller_info?.seller_name?.length > 25 ? `${offer?.seller_info?.seller_name?.substr(0, 20)}...` : offer?.seller_info?.seller_name}
                      </div>
                      <div className="material-shortage__offer-info">
                        <div className="material-shortage__offer-price">
                          {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"} /> : MONEY(offer?.offer_price)}
                          {' '}
                          &nbsp;
                        </div>
                        {offer?.is_preferred_supplier && (
                          <div
                            className="status-tag"
                            style={{ backgroundColor: 'orange' }}
                          >
                            Preferred
                          </div>
                        )}
                      </div>
                    </div>
                  </Option>
                ))}

              </PRZSelect>
              {numberOfSellers > 1 && (
                <Tooltip
                  title={numberOfSellers > 1 && tooltipText}
                  color="rgb(240, 246, 254)"
                  overlayClassName="custom-tooltip"
                >
                  <div
                    className="table-subscript"
                    style={{
                      position: 'absolute',
                      top: '30px',
                      left: '100px',
                    }}
                  >
                    {vendorDisplayText}
                  </div>
                </Tooltip>
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const getStockItemsInnerColumns = () => {
    const mrpColumns = [
      {
        title: 'Order#',
        width: '96px',
        fixed: 'left',
        render: () => '',
      },
      {
        title: 'Order#',
        fixed: 'left',
        width: '180px',
        render: (record) => {
          const productItems = record?.mo_finished_goods?.map((product) => (
            <div key={product?.product_sku_id}>
              <div
                onClick={() => window.open(`/inventory/product/view/${product?.product_sku_id}`)}
                style={{
                  cursor: 'pointer',
                  color: '#007bff',
                  fontSize: '12px',
                  lineHeight: '1.4',
                  padding: '4px',
                }}
              >
                <div style={{ fontWeight: 'bold' }}>
                  {product?.internal_sku_code ? ` ${product.internal_sku_code}` : ''}
                  {' '}
                  {product?.ref_product_code ? ` - ${product.ref_product_code}` : ''}
                </div>
                <div style={{ color: '#555' }}>{product?.product_sku_name || ''}</div>
              </div>
            </div>
          ));

          return (
            <div
              style={{ width: '164px' }}
            >
              <Popover
                placement="bottomLeft"
                content={(
                  <div style={{
                    maxHeight: '150px',
                    overflowY: 'auto',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    padding: '4px',
                  }}
                  >
                    {productItems}
                  </div>
                )}
                trigger="hover"
              >
                {record?.mo_number ? (
                  <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
                    {record?.mo_number}
                  </Link>
                ) : (
                  <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                    {record?.sales_order_number}
                  </Link>
                )}
              </Popover>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY((record?.issued_quantity ? record?.issued_quantity : record?.invoiced_quantity) || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {`${QUANTITY((record?.reserved_quantity), record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
                  </div>
                  {(Number(record?.available_quantity) + Number(record?.reserved_quantity)) > 0 && (
                    <div
                      className="material-shortage__reserve-button"
                      onClick={() => {
                        setReserveDrawerOpen(true);
                        setOrder(record);
                      }}
                    >
                      <EditOutlined />
                    </div>
                  )}
                </div>
                <div style={{
                  paddingRight: '5px', width: '80px', cursor: 'pointer',
                }}
                >
                  <Popover
                    title={(
                      <div>
                        <H3Text text={`${record?.demand_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                        <H3Text text={`${record?.reserved_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                      </div>
                    )}
                    zIndexPopup={99999}
                  >
                    <H3Progress percent={parseInt((record?.reserved_quantity / record?.demand_quantity) * 100)} barWidth="150px" />
                  </Popover>
                </div>
              </Fragment>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Purchased',
        width: '140px',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div>{`${QUANTITY(record?.purchase_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Safety Stock',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div className={ignoreStockItemsSafetyStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.threshold_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div>
                {`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available',
        render: (record) => <div style={{ minWidth: '70px' }}>-</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'To Be Ordered',
        width: '110px',
        fixed: 'right',
        render: (record) => (
          <Fragment>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Vendor',
        fixed: 'right',
        width: '200px',
        className: 'material-shortage__vendor-column',
        render: (record) => (
          <Fragment>
            <PRZSelect
              value={record?.sku_offer_id}
              filterOption={false}
              // getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placeholder={(
                <span className="material-shortage__vendor-column-empty">
                  <FontAwesomeIcon icon={faCircleExclamation} />
                  {' '}
                  &nbsp;Vendor Not Selected
                </span>
              )}
              onChange={(value) => {
                handleSellerSelection('', value, record?.order_line_id, record?.mo_line_id);
              }}
              popupClassName="material-shortage__vendor-dropdown"
              dropdownRender={(menu) => (
                <React.Fragment>
                  {menu}
                  <Divider style={{ margin: '0px' }} />
                  <div
                    className="add__vendor"
                    onClick={() => {
                      setSelectOfferVisible(true);
                      setCurrentLine({
                        ...record,
                        tenantProductId: record?.tenant_product_id,
                        productName: record?.product_sku_name,
                        productSkuId: record?.product_sku_info?.product_sku_id,
                      });
                      getOffers(record.tenant_product_id, '');
                    }}
                    style={{ cursor: 'pointer', padding: '8px' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',

                      }}
                    >
                      <FontAwesomeIcon icon={faGears} />

                      {' '}
                      Manage Vendors
                    </div>
                  </div>
                </React.Fragment>
              )}
            >
              {record?.sku_offers?.map((offer) => (
                <Option key={offer.sku_offer_id} value={offer.sku_offer_id}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  >
                    <div
                      style={{
                        fontWeight: '600', fontSize: '13px', marginRight: '5px',
                      }}
                    >
                      {offer?.seller_info?.seller_name?.length > 25 ? `${offer?.seller_info?.seller_name?.substr(0, 20)}...` : offer?.seller_info?.seller_name}
                    </div>
                    <div className="material-shortage__offer-info">
                      <div className="material-shortage__offer-price">
                        {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"} /> : MONEY(offer?.offer_price)}
                        {' '}
                        &nbsp;
                      </div>
                      {offer?.is_preferred_supplier && (
                        <div
                          className="status-tag"
                          style={{ backgroundColor: 'orange' }}
                        >
                          Preferred
                        </div>
                      )}
                    </div>
                  </div>
                </Option>
              ))}
            </PRZSelect>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Selected Vendor',
        fixed: 'right',
        width: '200px',
        className: 'material-shortage__vendor-column',
        render: (record) => {
          const skyOfferIds = record?.lines?.filter((item) => item?.sku_offer_id)?.map((item) => item?.sku_offer_id);
          return (
            <div>
              <PRZSelect
                value={skyOfferIds}
                filterOption={false}
                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder={(
                  <span className="material-shortage__vendor-column-empty">
                    <FontAwesomeIcon icon={faCircleExclamation} />
                    {' '}
                    &nbsp;Vendor Not Selected
                  </span>
                )}
                onChange={(value) => {
                  handleSellerSelection('', value, record?.lines?.map((item) => item?.order_line_id), record?.lines?.map((item) => item?.mo_line_id));
                }}
                popupClassName="material-shortage__vendor-dropdown"
                dropdownRender={(menu) => (
                  <React.Fragment>
                    {menu}
                    <Divider style={{ margin: '0px' }} />
                    <div
                      className="add__vendor"
                      onClick={() => {
                        setSelectOfferVisible(true);
                        setCurrentLine({
                          ...record,
                          tenantProductId: record?.lines?.[0]?.tenant_product_id,
                          productName: record?.lines?.[0]?.product_sku_name,
                          productSkuId: record?.lines?.[0]?.product_sku_info?.product_sku_id,
                        });
                        getOffers(record?.lines?.[0]?.tenant_product_id, '');
                      }}
                      style={{ cursor: 'pointer', padding: '8px' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '5px',
                        }}
                      >
                        <FontAwesomeIcon icon={faGears} />

                        {' '}
                        Manage Vendors
                      </div>
                    </div>
                  </React.Fragment>
                )}
              >
                {record?.lines?.[0]?.sku_offers?.map((offer) => (
                  <Option key={offer.sku_offer_id} value={offer.sku_offer_id}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    >
                      <div
                        style={{
                          fontWeight: '600', fontSize: '13px', marginRight: '5px',
                        }}
                      >
                        {offer?.seller_info?.seller_name?.length > 25 ? `${offer?.seller_info?.seller_name?.substr(0, 20)}...` : offer?.seller_info?.seller_name}
                      </div>
                      <div className="material-shortage__offer-info">
                        <div className="material-shortage__offer-price">
                          {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"} /> : MONEY(offer?.offer_price)}
                          {' '}
                          &nbsp;
                        </div>
                        {offer?.is_preferred_supplier && (
                          <div
                            className="status-tag"
                            style={{ backgroundColor: 'orange' }}
                          >
                            Preferred
                          </div>
                        )}
                      </div>
                    </div>
                  </Option>
                ))}
              </PRZSelect>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  function mergeEntries(data) {
    // Object to store the merged results
    const mergedResults = {};
    // Iterate over each tenant_id in the data
    Object.keys(data).forEach((tenantId) => {
      const entries = data[tenantId];
      const mergedEntries = [];

      // Iterate over each entry for the current tenant
      entries.forEach((entry) => {
        const existingEntryIndex = mergedEntries.findIndex((e) => e.product_sku_id === entry.product_sku_id);

        if (existingEntryIndex !== -1) {
          // If the product_sku_id already exists, add the quantities
          mergedEntries[existingEntryIndex].quantity += entry.quantity;
        } else {
          // If it's a new product_sku_id, clone the entry and add it to mergedEntries
          mergedEntries.push(JSON.parse(JSON.stringify(entry)));
        }
      });
      // Assign the merged entries back to the corresponding tenant in the results
      mergedResults[tenantId] = mergedEntries;
    });
    setTenantSellerPRItemsData(mergedResults);
  }

  function convertToPo(selectedRows) {
    // const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
    const selectedPrLines = JSON.parse(JSON.stringify(selectedRows));
    const tenantSellerPRItems = {};
    const defaultSeqPrefix = documentSequence?.document_sequences?.find(item => item?.is_default)?.seq_prefix || '';
    const defaultSeqId = documentSequence?.document_sequences?.find(item => item?.is_default)?.seq_id || '';
    for (let i = 0; i < selectedPrLines?.length; i++) {
      const prLine = { ...selectedPrLines?.[i], lineCustomFields: cfPurchaseOrdersLine };
      if (tenantSellerPRItems.hasOwnProperty(prLine?.selected_sku_offer?.tenant_seller_id)) {
        tenantSellerPRItems[prLine?.selected_sku_offer?.tenant_seller_id].push(prLine);
      } else {
        const defaultExpiryDays = user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.default_expiry_days;
        tenantSellerPRItems[prLine?.selected_sku_offer?.tenant_seller_id] = [{
          ...prLine,
          tenant_department_id: Helpers.getDefaultTenantDepartmentIdForSelectedTenant(user, selectedPrLines?.[0]?.tenant_id),
          po_date: dayjs(),
          delivery_date: dayjs(),
          expiry_date: defaultExpiryDays ? dayjs().add(defaultExpiryDays, 'day') : dayjs(),
          payment_terms: prLine?.selected_sku_offer?.default_payment_terms?.due_days,
          gst_number: prLine?.selected_sku_offer?.gst_number,
          documentCustomFields: cfPurchaseOrdersDoc,
          poNumber: `${defaultSeqPrefix}`,
          docSeqId: defaultSeqId,
          showAddressDrawer: false,
          vendorAddress: prLine?.selected_sku_offer?.office_address_details,
          billingAddress: user?.user_tenants?.find((tenant) => tenant?.tenant_id === prLine?.tenant_id)?.default_billing_address_info,
          selectedAddressType: "",
        }];
      }
    }
    mergeEntries(tenantSellerPRItems);
  }

  function customLineInputChange(fieldValue, key, item) {
    const copyData = JSON.parse(JSON.stringify(item));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i]?.key === key) {
        copyData[i].lineCustomFields = fieldValue;
      }
    }

    return copyData;
  }

  const handleCreatePurchaseOrder = () => {
    // First, check if any selectedMaterialShortageItemRows are missing the sku_offer_id

    const isMissingSkuOfferId = !consolidateStockItems ? selectedMaterialShortageItemRows?.some((item) => !item?.selected_sku_offer?.sku_offer_id) : selectedMaterialShortageItemRows.some((batch) => batch.lines.some((item) => !item?.selected_sku_offer?.sku_offer_id));
    if (isMissingSkuOfferId) {
      // If any row is missing the sku_offer_id, show a notification and stop the process
      notification.error({
        message: 'Some items are missing Vendor details. Please select an vendor for all items before proceeding.',
        duration: 4,
        placement: 'top',
      });
      return; // Stop the function execution here
    }

    const checkIsConsolidated = !consolidateStockItems ? selectedMaterialShortageItemRows : selectedMaterialShortageItemRows?.map((batch) => batch?.lines).flat();
    // If all items have a sku_offer_id, proceed with the original logic
    const selectedRows = checkIsConsolidated?.map((item) => {
      const selectedSkuOffer = item.selected_sku_offer;
      return {
        ...item,
        sku_offer_id: selectedSkuOffer.sku_offer_id,
        seller_id: selectedSkuOffer.seller_id,
        seller_name: selectedSkuOffer.seller_name,
        unitPrice: selectedSkuOffer.offer_price,
        quantity: isPoFromMrpInPurchaseUomEnable ? (
          (item?.pending_quantity || 0)
          * (item?.uom_info?.[0]?.ratio || 1)
        )
          / (item?.product_sku_info?.purchase_uom_info?.ratio || 1) : item.pending_quantity,
        uomId: isPoFromMrpInPurchaseUomEnable ? item.product_sku_info.purchase_uom_info?.uom_id : item?.uom_info?.[0]?.uom_id,
        uomInfo: isPoFromMrpInPurchaseUomEnable ? item.product_sku_info.purchase_uom_info : item?.uom_info,
        tax_id: item?.tax_info?.tax_id,
        taxInfo: item?.tax_info,
        key: uuidv4(),
      };
    });
    convertToPo(selectedRows);

    setSelectedPurchaseRequest(selectedRows);
    setCreatePurchaseDrawer(true);
  };

  function customInputChange(fieldValue, cfId, documentCustomFields) {
    let newCfPurchaseOrdersDoc = JSON.parse(JSON.stringify(documentCustomFields));
    const newCustomFields = newCfPurchaseOrdersDoc.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url,
              type: attachment.type,
              name: attachment.name,
              uid: attachment.uid,
            })),
          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    return newCustomFields;
  }

  function updateSellerInfo(tenantSellerId, label, value, key, cfId) {
    // Deep copy to avoid direct state mutation
    const prItemsCopy = JSON.parse(JSON.stringify(tenantSellerPRItemsData));

    // Check if the tenantSellerId exists and has an array
    if (prItemsCopy.hasOwnProperty(tenantSellerId) && Array.isArray(prItemsCopy[tenantSellerId])) {

      let updatedItems = [];

      if (label === 'lineCustomFields') {
        updatedItems = customLineInputChange(value, key, prItemsCopy[tenantSellerId]);
      } else if (label === 'poNumber') {
        updatedItems = prItemsCopy[tenantSellerId]?.map((item) => {
          // Check if the current item is the one to update
          if (item.key === key) {
            // Update the poNumber for the specific item
            item.poNumber = value?.poNumber || '';
            item.docSeqId = value?.docSeqId || '';
          }
          return item;
        }
        );
      } else if (label === 'vendorAddress' || label === 'billingAddress') {
        updatedItems = prItemsCopy[tenantSellerId]?.map((item) => {
          // Check if the current item is the one to update
          if (item.key === key) {
            item[label] = value || '';
            item.showAddressDrawer = false || '';
          }
          return item;
        }
        );
      } else if (label === 'selectedAddressType') {
        updatedItems = prItemsCopy[tenantSellerId]?.map((item) => {
          // Check if the current item is the one to update
          if (item.key === key) {
            item[label] = value || '';
            item.showAddressDrawer = true || '';
          }
          return item;
        }
        );
      }
      else {
        // Map through the array to find and update the correct item
        updatedItems = prItemsCopy[tenantSellerId]?.map((item) => {
          // Check if the current item is the one to update
          if (item.key === key) {
            // Specific updates for the 'tax' label
            if (label === 'tax') {
              item.tax_id = value?.tax_id;
              item.tax_name = value?.tax_name;
              item.tax_value = value?.tax_value;
              item.taxInfo = value; // Assuming you want to replace the whole taxInfo
            } else if (label === 'uomId') {
              item.uomId = value;
              item.uomInfo = item?.product_uom_list?.find((rec) => rec?.uom_id === value);
            } else if (label === 'documentCustomFields') {
              item.documentCustomFields = customInputChange(value, cfId, item.documentCustomFields);
            } else {
              // Update for any other label
              item[label] = value;
            }
          }
          return item;
        });
      }

      // Update the copy with the modified items
      prItemsCopy[tenantSellerId] = updatedItems;
    }
    // Finally, set the updated data back to your state or wherever it needs to go
    setTenantSellerPRItemsData(prItemsCopy);
  }

  function isDataValid() {
    const copyTenantSellerPRItems = JSON.parse(JSON.stringify(Object.values(tenantSellerPRItemsData)));

    for (const subArray of copyTenantSellerPRItems) {
      if (
        !subArray[0]?.po_date
        || (Number(subArray[0]?.unitPrice) === 0)
        || (Number(subArray[0]?.quantity) === 0)
      ) {
        return false;
      }
      if (subArray[0]?.documentCustomFields?.length > 0) {
        for (const field of subArray[0]?.documentCustomFields) {
          if (field?.isRequired && !field?.fieldValue && field?.isActive) {
            return false;
          }
        }
      }
      if (subArray[0]?.lineCustomFields?.length > 0) {
        for (const field of subArray[0]?.lineCustomFields) {
          if (field?.isRequired && !field?.fieldValue && field?.fieldName !== "Rate" && field?.fieldName !== "Quantity") {
            return false;
          }
        }
      }
    }
    return true;
  }

  const handleReserveShortage = (clear) => {
    const moIds = setConsolidateStockItems ? selectedMaterialShortageItemRows?.map((item) => item?.lines?.filter((item) => item?.mo_id)?.map((line) => line?.mo_line_id))?.flat() : selectedMaterialShortageItemRows?.filter((item) => item?.mo_id)?.map((item) => item?.mo_line_id);
    const soIds = setConsolidateStockItems ? selectedMaterialShortageItemRows?.map((item) => item?.lines?.filter((item) => item?.order_id)?.map((line) => line?.order_line_id))?.flat() : selectedMaterialShortageItemRows?.filter((item) => item?.order_id)?.map((item) => item?.order_line_id);

    const payload = {
      so_line_ids: soIds,
      mo_line_ids: moIds,
      mrp_id: mrpId,
      type: 'AVAILABLE_STOCK',
    };

    if (clear) {
      clearReservation(payload, () => {
        setCallStockItem(!callStockItem);
      });
    } else {
      reserveShortageMrp(payload, () => {
        setCallStockItem(!callStockItem);
      });
    }
  };
  return (
    <Fragment>
      {/* for link Existing po */}
      <Drawer
        width="1110px"
        placement="right"
        onClose={() => setLinkExistingPoToMrpDrawer(false)}
        open={linkExistingPoToMrpDrawer}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
            style={{
              position: 'static',
              width: '1065px',
            }}
          >
            <H3Text
              text="Link Production Orders to this Materials Plan"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setLinkExistingPoToMrpDrawer(false)}
            />
          </div>
          <LinkExistingPoToMrp
            mrpId={mrpId}
            mrpData={mrpData}
            productSkuIds={selectedMaterialShortageItemRowKeys}
            selectedProductLines={selectedMaterialShortageItemRows}
            ignoreStockItemsSafetyStock={ignoreStockItemsSafetyStock}
            ignoreStockItemsAvailableStock={ignoreStockItemsAvailableStock}
            callback={() => {
              setLinkExistingPoToMrpDrawer(false);
              setCallStockItem(!callStockItem);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        onClose={() => setCreatePurchaseDrawer(false)}
        open={createPurchaseDrawer}
        width="1050px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1000px' }}>
            <H3Text text="Create Purchase Orders" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setCreatePurchaseDrawer(false)} />
          </div>
        </div>
        <PRFromMaterialShortage
          selectedPurchaseRequest={mrpData}
          poFromMrpScreen={isPoFromMrpInPurchaseUomEnable}
          tenantSellerPRItems={tenantSellerPRItemsData}
          updateSellerInfo={(tenantSellerId, label, value, key, cfId) => updateSellerInfo(tenantSellerId, label, value, key, cfId)}
          callback={() => {
            setCreatePurchaseDrawer(false);
            setCallStockItem(!callStockItem);
            poCreateCallback();
          }}
          customLineInputChange={(fieldValue, key, type, isManualControlCustomField) => customLineInputChange(fieldValue, key, type, isManualControlCustomField)}
          cfPurchaseOrdersLine={cfPurchaseOrdersLine}
          visibleColumns={visibleColumns}
          isDataValid={() => isDataValid()}
          taxesGroupData={taxesGroupData}
          getTaxesLoading={getTaxesLoading}
        />
      </Drawer>
      <Drawer
        onClose={() => setReserveDrawerOpen(false)}
        open={reserveDrawerOpen}
        width="970px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '920px' }}>
            <H3Text text="Reservation" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setReserveDrawerOpen(false);
                setCallStockItem(!callStockItem);
              }}
            />
          </div>
        </div>
        <ReserveMrpStockItems
          order={order}
          callback={() => {
            setReserveDrawerOpen(false);
            setCallStockItem(!callStockItem);
          }}
          mrpId={mrpId}
        />
      </Drawer>
      <Drawer
        onClose={() => setEditPurchaseLinkAndUnlinkDrawer(false)}
        open={editPurchaseLinkAndUnlinkDrawer}
        width="1060px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1010px' }}>
            <H3Text text="Link/Unlink Purchase Orders" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setEditPurchaseLinkAndUnlinkDrawer(false);
                setCallStockItem(!callStockItem);
              }}
            />
          </div>
        </div>
        <EditPurchaseLinkAndUnlink
          PoData={dataForLinkAndUnlinkPo}
          stockItemsShortage={stockItemsShortage}
          loading={getStockItemsShortageLoading}
          tenantId={mrpData?.tenant_id}
          mrpData={mrpData}
          productSkuIds={dataForLinkAndUnlinkPo?.product_sku_id}
          callback={() => {
            setCallStockItem(!callStockItem);
          }}
          mrpId={mrpId}
        />
      </Drawer>
      <Drawer
        onClose={() => setCreatePurchaseRequestDrawer(false)}
        open={createPurchaseRequestDrawer}
        width="1150px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1090px' }}>
            <H3Text text="Material Request" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setCreatePurchaseRequestDrawer(false);
                setCallStockItem(!callStockItem);
              }}
            />
          </div>
        </div>
        <CreatePurchaseRequest
          mrpToPrData={selectedMaterialShortageItemRows}
          mrpId={mrpId}
          mrpData={mrpData}
        />
      </Drawer>
      <Drawer
        onClose={() => setCreatePurchaseIndentDrawer(false)}
        open={createPurchaseIndentDrawer}
        width="1150px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1090px' }}>
            <H3Text text="Purchase Indent" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setCreatePurchaseIndentDrawer(false);
                setCallStockItem(!callStockItem);
              }}
            />
          </div>
        </div>
        <PurchaseIndentForm
          mrpToPiData={selectedMaterialShortageItemRows}
          selectedMRP={mrpData}
        />
      </Drawer>
      <SelectOffer
        selectOfferVisible={selectOfferVisible}
        toggleOfferModal={() => setSelectOfferVisible(!selectOfferVisible)}
        currentLine={currentLine}
        handleSellerSelection={handleSellerSelection}
        type="order"
        tenantId={mrpData?.tenant_id}
        newCallback={() => setCallStockItem(!callStockItem)}
      />
      <div className="material-shortage__wrapper">

        <div className="material-shortage__lower-wrapper">
          <div className="material-shortage__table-wrapper">
            <div className="material-shortage__table-title__button-wrapper">
              <Button
                type="primary"
                onClick={() => {
                  handleReserveShortage(false);
                }}
                customClass="mrp__add-button"
                disabled={selectedMaterialShortageItemRows?.length === 0}
                loading={reserveShortageMrpLoading}
              >
                Reserve Stock
              </Button>
              &nbsp;&nbsp;
              {user?.tenant_info?.production_config?.addons?.material_planing?.settings?.enable_po_creation_from_mrp &&
                Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) &&
                <Button
                  type="primary"
                  onClick={() => {
                    handleCreatePurchaseOrder();
                  }}
                  disabled={selectedMaterialShortageItemRows?.length === 0}
                >
                  + Purchase Orders
                </Button>}
              &nbsp;&nbsp;
              {user?.tenant_info?.production_config?.addons?.material_planing?.settings?.enable_mr_creation_from_mrp &&
                Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE, user) &&
                <Button
                  type="primary"
                  onClick={() => {
                    setCreatePurchaseRequestDrawer(true);
                  }}
                  disabled={selectedMaterialShortageItemRows?.length === 0}
                >
                  + Material Request
                </Button>
              }
              &nbsp;&nbsp;
              {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) &&
                user?.tenant_info?.production_config?.addons?.material_planing?.settings?.enable_pi_creation_from_mrp
                &&
                <Button
                  type="primary"
                  onClick={() => {
                    setCreatePurchaseIndentDrawer(true);
                  }}
                  disabled={selectedMaterialShortageItemRows?.length === 0}
                >
                  + Purchase Indent
                </Button>}
              &nbsp;&nbsp;
              <Button
                danger
                onClick={() => {
                  handleReserveShortage(true);
                }}
                disabled={selectedMaterialShortageItemRows?.length === 0}
                loading={clearReservationLoading}
              >
                Clear Reservation
              </Button>
              &nbsp;&nbsp;
              <Button
                type="primary"
                onClick={() => {
                  setLinkExistingPoToMrpDrawer(true);
                }}
                disabled={selectedMaterialShortageItemRows?.length === 0}
              >
                + Existing Purchase Orders
              </Button>
              &nbsp;&nbsp;
              {
                stockItemsShortage?.data && (getStockItemsShortageLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading || reserveShortageMrpLoading)
                && <H3Image src={loaderImg} className="table-mini-loader" />
              }
            </div>
            <Table
              title={() => (
                <div className="material-shortage__table-title__wrapper">
                  <H3Text className="material-shortage__table-title-count" text={stockItemsShortage?.data?.length || '0'} />
                  Materials Required
                  <div className="material-shortage__checkbox-wrapper">
                    <div className="flex-display">
                      {/* <div> */}
                      {/*  <Checkbox */}
                      {/*    checked={consolidateStockItems} */}
                      {/*    onChange={(e) => { */}
                      {/*      setConsolidateStockItems(e.target.checked); */}
                      {/*      getStockItemsSuccess(null, 'SHORTAGE'); */}
                      {/*      updateMrpV2({ */}
                      {/*        mrp_id: mrpId, */}
                      {/*        consolidate_requirement_mrp_stock_items: e.target.checked, */}
                      {/*      }, () => setCallStockItem(!callStockItem)); */}
                      {/*    }} */}
                      {/*    disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading} */}
                      {/*  > */}
                      {/*    Consolidate Requirement */}
                      {/*  </Checkbox> */}
                      {/* </div> */}
                      <div>
                        <Checkbox
                          checked={ignoreStockItemsAvailableStock}
                          onChange={(e) => {
                            setIgnoreStockItemsAvailableStock(e.target.checked);
                            getStockItemsSuccess(null, 'SHORTAGE');
                            updateMrpV2({
                              mrp_id: mrpId,
                              ignore_available_stock_mrp_stock_items: e.target.checked,
                            }, () => setCallStockItem(!callStockItem));
                          }}
                          disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                        >
                          Ignore Available Stock
                        </Checkbox>
                      </div>
                      <div>
                        <Checkbox
                          checked={ignoreStockItemsSafetyStock}
                          onChange={(e) => {
                            setIgnoreStockItemsSafetyStock(e.target.checked);
                            getStockItemsSuccess(null, 'SHORTAGE');
                            updateMrpV2({
                              mrp_id: mrpId,
                              ignore_safety_stock_mrp_stock_items: e.target.checked,
                            }, () => setCallStockItem(!callStockItem));
                          }}
                          disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                        >
                          Ignore Safety Stock
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              bordered
              loading={(!stockItemsShortage?.data || updateMrpStockItemsLoading) && (getStockItemsShortageLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading || reserveShortageMrpLoading || updateMrpStockItemsLoading)}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              columns={consolidateStockItems ? getStockItemsColumns()?.filter((item) => !['Order#', 'Vendor'].includes(item.title)) : getStockItemsColumns()?.filter((item) => !['Order#', 'Selected Vendor', 'Reserved E'].includes(item.title))}
              dataSource={stockItemsShortage?.data ? stockItemsShortage?.data?.map((item) => ({
                ...item,
                key: consolidateStockItems ? item?.product_sku_id : (item?.order_line_id || item?.mo_line_id),
              })) : []}
              pagination={false}
              rowSelection={(window.screen.width > 425) ? {
                onChange: (rowKeys, rows) => {
                  setSelectedMaterialShortageItemRows(rows);
                  setSelectedMaterialShortageItemRowKeys(rowKeys);
                },
                selectedRowKeys: selectedMaterialShortageItemRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: ['NON_STORABLE', 'SERVICE'].includes(record?.product_type),
                }),
              } : false}
              rowClassName={(rec) => (rec?.is_material_available ? '' : 'material-shortage__short-row')}
              expandable={consolidateStockItems && {
                expandedRowRender: (record) => (
                  <Table
                    showHeader
                    bordered
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={getStockItemsInnerColumns()?.filter((item) => !['Selected Vendor'].includes(item.title))}
                    dataSource={record?.lines ? record?.lines?.map((item) => ({
                      ...item,
                      key: item?.order_line_id,
                    })) : []}
                    pagination={false}
                  />
                ),
                rowExpandable: (record) => record?.lines?.length > 0,
              }}
            />
          </div>
        </div>

      </div>
    </Fragment >
  );
}

const mapStateToProps = ({
  UserReducers, MrpV2Reducers, GetDocSequence, TaxReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getLinkedMOLoading: MrpV2Reducers.getLinkedMOLoading,
  pushToProductionItemsLoading: MrpV2Reducers.pushToProductionItemsLoading,
  getStockItemsShortageLoading: MrpV2Reducers.getStockItemsShortageLoading,
  pushToStockItemsLoading: MrpV2Reducers.pushToStockItemsLoading,
  updateMrpV2Loading: MrpV2Reducers.updateMrpV2Loading,
  linkedMO: MrpV2Reducers.linkedMO,
  stockItemsShortage: MrpV2Reducers.stockItemsShortage,
  updateMrpProductionLoading: MrpV2Reducers.updateMrpProductionLoading,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
  mrpV2: MrpV2Reducers.mrpV2,
  reserveShortageMrpLoading: MrpV2Reducers.reserveShortageMrpLoading,
  clearReservationLoading: MrpV2Reducers.clearReservationLoading,
  updateMrpStockItemsLoading: MrpV2Reducers.updateMrpStockItemsLoading,
  priceMasking: UserReducers.priceMasking,
  documentSequence: GetDocSequence.data,
  getTaxesLoading: TaxReducers.getTaxesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getMrpV2: (payload, callback) => dispatch(MrpV2Actions.getMrpV2(payload, callback)),
  getLinkedMO: (payload, callback) => dispatch(MrpV2Actions.getLinkedMO(payload, callback)),
  getLinkedMOSuccess: (linkedMO) => dispatch(MrpV2Actions.getLinkedMOSuccess(linkedMO)),
  getStockItems: (payload, callback) => dispatch(MrpV2Actions.getStockItems(payload, callback)),
  getStockItemsSuccess: (stockItems, entityType) => dispatch(MrpV2Actions.getStockItemsSuccess(stockItems, entityType)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  pushToProductionItems: (payload, callback) => dispatch(MrpV2Actions.pushToProductionItems(payload, callback)),
  pushToStockItems: (payload, callback) => dispatch(MrpV2Actions.pushToStockItems(payload, callback)),
  updateMrpV2: (payload, callback) => dispatch(MrpV2Actions.updateMrpV2(payload, callback)),
  updateMrpProduction: (payload, callback) => dispatch(MrpV2Actions.updateMrpProduction(payload, callback)),
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  updateMrpStockItems: (payload, callback) => dispatch(MrpV2Actions.updateMrpStockItems(payload, callback)),
  reserveShortageMrp: (payload, callback) => dispatch(MrpV2Actions.reserveShortageMrp(payload, callback)),
  clearReservation: (payload, callback) => dispatch(MrpV2Actions.clearReservation(payload, callback)),
  getMrpSummary: (payload, callback) => dispatch(MrpV2Actions.getMrpSummary(payload, callback)),
  getDocSequence: (payload, callback) => dispatch(GetDocSequence.actions.request(payload, callback)),
  getTaxes: (tenantId, page, limit, isActive, isTaxGroup, callback) => dispatch(TaxActions.getTaxes(tenantId, page, limit, isActive, isTaxGroup, callback)),
  getTaxesSuccess: (taxes) => dispatch(TaxActions.getTaxesSuccess(taxes)),
});

MaterialShortage.propTypes = {
  user: PropTypes.any,
  linkedMO: PropTypes.any,
  stockItemsShortage: PropTypes.any,
  getLinkedMO: PropTypes.func,
  getStockItems: PropTypes.func,
  getLinkedMOLoading: PropTypes.bool,
  getStockItemsShortageLoading: PropTypes.bool,
  getMrpV2: PropTypes.func,
  getOffers: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MaterialShortage));
